/**
 * Get all values from an array by the given path
 *  -> Path can nested values by seperating with dots (e.g. foo.bar.id)
 *
 * @param array
 * @param path
 * @param flatten
 * @returns {Array}
 */
export function pluckPath(array, path, flatten = false): Array<any> {

    let result       = [];
    const nestedKeys = path.split('.');
    const key        = nestedKeys.shift();
    const nextPath   = nestedKeys.length >= 1 ? nestedKeys.join('.') : false;

    array.forEach(item => {

        // match first item of path?
        if (item[key]) {

            if (nextPath) {
                // nextPath?
                if (flatten) {
                    result = result.concat(pluckPath(item[key], nextPath, flatten));
                } else {
                    result.push(pluckPath(item[key], nextPath));
                }

            } else {
                // no nextPath ? -> return value
                if (flatten) {
                    result = result.concat(item[key]);
                } else {
                    result.push(item[key]);
                }
            }

        }

    });

    return result;
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/helpers/pluck-path.function.ts